import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  margin-top: 1rem;
  gap: 2rem;
  align-items: center;
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.grayDark4};
  font-family: ${({ theme }) => theme.fonts.workSans};

  button {
    width: 10.75rem;
  }
`;

export const RangeTimeRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  gap: 3rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobileL}) {
    justify-content: center;
  }
`;

export const Subtitle = styled.div`
  font-weight: 600;
  white-space: pre-line;
  color: ${({ theme }) => theme.colors.darkBlue2};
`;

export const ContainerCheckboxWeek = styled.div`
  width: 10rem;
`;
